import { useEffect, useState } from 'react';
import { sb } from '../supabase';
import { fetchDisplayRates, getCachedDisplayRates } from './displayCurrency';

// CNY per USD at the admin rate, for the quote form's "≈ ¥X" reading aid on
// pages that have no exchangeRates prop (the public RFQ and factory-invite
// doors). Starts from the cached rates so the hint shows at once; display only.
export function useAdminCnyRate() {
  const [rate, setRate] = useState(() => getCachedDisplayRates().CNY);
  useEffect(() => {
    let off = false;
    fetchDisplayRates(sb)
      .then((r) => { if (!off && Number(r?.CNY) > 0) setRate(r.CNY); })
      .catch((e) => console.error('[useAdminCnyRate] rates unavailable:', e?.message || e));
    return () => { off = true; };
  }, []);
  return rate;
}
